module.exports = __webpack_public_path__ + "assets/slightly_frowning_face.3ac4e173b06b4fbdd301406b49c707b3.png";